module.exports = __webpack_public_path__ + "img/searchScreenRe1.6e37cc52.svg";